import * as esri from 'esri-leaflet';
import { TableData } from './types';

export default class FeatureLayerData {
  featureLayer: esri.FeatureLayer | null;
  tableData: TableData;

  constructor() {
    this.featureLayer = null;
    this.tableData = { items: [], fields: [], sortBy: '' };
  }
}
